import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTroubleshoot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25054",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25054)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M17.3672 17.46L13.218 13.3108C12.6272 13.7821 11.9974 14.1467 11.3286 14.4046C10.6599 14.6626 9.92592 14.7917 9.12676 14.7917C7.94078 14.7917 6.8644 14.5061 5.89759 13.935C4.93065 13.364 4.16356 12.6079 3.59634 11.6667H5.13301C5.62134 12.2393 6.20683 12.695 6.88947 13.0338C7.57224 13.3724 8.31801 13.5417 9.12676 13.5417C10.569 13.5417 11.7976 13.0342 12.8126 12.0192C13.8276 11.0043 14.3351 9.77569 14.3351 8.33333C14.3351 6.89097 13.8276 5.66236 12.8126 4.6475C11.7976 3.6325 10.569 3.125 9.12676 3.125C7.76245 3.125 6.58454 3.58736 5.59301 4.51208C4.60162 5.43667 4.05037 6.57153 3.93926 7.91667H2.68926C2.80037 6.21153 3.46995 4.77833 4.69801 3.61708C5.92606 2.45569 7.40231 1.875 9.12676 1.875C10.9291 1.875 12.4561 2.50083 13.7076 3.7525C14.9593 5.00403 15.5851 6.53097 15.5851 8.33333C15.5851 9.1325 15.4561 9.86778 15.198 10.5392C14.94 11.2107 14.5754 11.8419 14.1043 12.4327L18.2453 16.5737L17.3672 17.46ZM8.31905 11.5385L6.92634 6.92458L5.74697 10.2885H1.75488V9.29479H5.04822L6.42322 5.33646H7.48884L8.8478 9.89104L9.85592 6.79479H10.9215L12.1715 9.29479H12.8286V10.2885H11.5609L10.4776 8.12167L9.36384 11.5385H8.31905Z",
			fill: "#064C68"
		})
	})]
});
export default SvgTroubleshoot;
